import { find } from 'lodash';
import { getResourcesBySource } from '@/reducers/visualizationsReducer';
import { Resource } from '@/experiment-management-shared/api/library-panel/types';

export const getResourcesForTemplate = (
  code: string,
  internalResources: Resource[]
) => {
  const modifiedInternalResources = internalResources.map(
    ({ name, versions }) => {
      const defaultVersion = find(versions, 'isDefault');

      return {
        name,
        version: defaultVersion?.version,
        enabled: true
      };
    }
  );

  const versionMap = internalResources.reduce((result, resource) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    result[resource.name] = resource.versions.reduce((map, resourceVersion) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      map[resourceVersion.version] = resourceVersion.url;

      return map;
    }, {});
    return result;
  }, {});

  return getResourcesBySource(code, versionMap, modifiedInternalResources);
};
